import { Collection } from 'modules/core/lib/mobx-rest'
import type { SetOptions } from 'modules/core/lib/mobx-rest/types'

import type { IResourceField } from 'modules/custom_resources/store/models/customFields/ResourceField'
import ResourceField from 'modules/custom_resources/store/models/customFields/ResourceField'

interface Config {
  model_ref: string
  instance_id: string | number
}
type Data = Record<string, number | string>

class ResourceFieldsCollection extends Collection<ResourceField> {
  config: Config

  constructor(data: ResourceField[], config: Config) {
    super(data)
    this.set(data)
    this.config = config
  }

  get cacheKey(): string {
    return 'resourceFields'
  }

  get dynamicPath() {
    return `/custom_fields/resource_fields/${this.config.model_ref}/${this.config.instance_id}`
  }

  create(attributes: Partial<IResourceField>) {
    return super.create(attributes, { path: this.dynamicPath })
  }

  fetch(options: SetOptions = {}) {
    return super.fetch({ ...options, path: this.dynamicPath })
  }

  model() {
    return ResourceField
  }

  createByGroup(group: string, data: Data) {
    return this.create(
      Object.assign({}, data, {
        usage_group_slug: [group],
      })
    )
  }

  byUsageGroup(groups: string[], employeeId: number | null | undefined = null): Promise<any> {
    const data: {
      usage_group_slug: string[]
      employee_id?: number | null | undefined
    } = {
      usage_group_slug: groups,
    }

    if (employeeId) data.employee_id = employeeId

    return this.fetch({
      data,
    })
  }
}

export default ResourceFieldsCollection
